import { CompanyTypeEnum } from "./company-type-enum";

export class PlantsDropDown {
    plantId: number;
    plantName: string;
    plantType?: string;
    company?:CompanyTypeEnum

    /**
     * 
     * @param plantId 
     * @param plantName 
     */
    constructor(plantId: number, plantName: string, plantType?:string,company?:CompanyTypeEnum) {
        this.plantId = plantId;
        this.plantName = plantName;
        this.plantType = plantType;
        this.company = company
    }

}